style= require('./lineups.styl')
each lineup in this.teamLineup()
  - var shirt = lineup.player && (lineup.player.shirt || lineup.player.shirt === 0) ? lineup.player.shirt + '.' : '?'
  .player(
    class=this.playerClass(lineup),
    (click)=this.select(lineup))
    if lineup.batch
      .batch= lineup.batch
    if showShirt
      .shirt= shirt
    .name= lineup.player.name
    .position (#{lineup.player.pos})
    .events
      each event in eventsFor(lineup)
        ft-icon.default-col(name=event)
    .playtime= this.playtime(lineup) + ' min'

